import axios from 'axios';
import {backendHost} from '../../config';

export const getProviders = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/games/providers`, {params});
};